import { apiFetch } from './client';

export type ApiScope = 'gateway:invoke' | 'config:read' | 'ingest:write';

export interface ApiKeyMeta {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  appId: string | null;
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

// Returned ONCE on create — `apiKey` (the full prefix.secret) is never retrievable again.
export interface CreatedApiKey {
  id: string;
  name: string;
  prefix: string;
  apiKey: string;
  scopes: string[];
  createdAt: string;
}

export interface CreateApiKeyParams {
  name: string;
  scopes: ApiScope[];
  appId?: string; // project slug pin (optional)
}

export const listApiKeys = (orgId: string) =>
  apiFetch<ApiKeyMeta[]>(`/orgs/${orgId}/api-keys`);

export const createApiKey = (orgId: string, params: CreateApiKeyParams) =>
  apiFetch<CreatedApiKey>(`/orgs/${orgId}/api-keys`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

export const revokeApiKey = (orgId: string, id: string) =>
  apiFetch<{ id: string; revoked: boolean }>(`/orgs/${orgId}/api-keys/${id}/revoke`, {
    method: 'POST',
  });
